import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import endpoints from '../../../config/endpoints';

import http from '../../shared/http';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';

import qs from 'qs';
import cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';

import values from 'lodash/values';

const defaultTableInitialState = {
	columns: {
		id: {
			index: 'id',
			title: 'ID',
			direction: 'desc',
			isActive: false,
			className: 'id'
		},
		partner_name: {
			index: 'partner_name',
			isActive: true,
			title: 'Partner',
			direction: 'asc',
			className: 'id'
		},
		partner_description_ru: {
			index: 'partner_description_ru',
			title: 'Partner description ru',
			className: 'title modify_border'
		},
		partner_description_en: {
			index: 'partner_description_en',
			title: 'Partner description en',
			className: 'title modify_border'
		},
		ends_at: {
			index: 'ends_at',
			title: 'Ends at',
			className: 'title modify_border'
		},
		actions: {
			title: 'Actions',
			className: 'actions'
		}
	}
};

// action types
const FETCH_DATA_SUCCESS = 'DISCOUNTS-LIST/FETCH_DATA_SUCCESS';
const FETCH_DATA_ERROR = 'DISCOUNTS-LIST/fetch-data-error';

const TOGGLE_PROGRESS_BAR = 'DISCOUNTS-LIST/toggle-progress-bar';
const TOGGLE_SORT = 'DISCOUNTS-LIST/toggle-sort';
const PAGINATE = 'DISCOUNTS-LIST/paginate';

const DELETE_NEWS_SUCCESS = 'DISCOUNTS-LIST/delete-news-success';

// permissions
export const allowedPermissions = {
	view: 'discounts_list',
	edit: 'discounts_create',
	delete: 'discounts_delete'
};

const paginationCount = 10;

// initial state
const initialState = {
	data: null,
	table: defaultTableInitialState,
	query: {
		limit: paginationCount,
		sort: {partner_name: 'asc'},
		offset: 0
	},
	defaultLanguage: 'en',
	showProgressBar: false,
	error: false
};
// actions
export const actions = Object.assign(
	{
		fetchData: () => (dispatch, getState) => {
			const { query } = getState().discountsList;
			http({
				url: `${endpoints.DISCOUNTS.BASE}?${qs.stringify(query)}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			})(dispatch);
		},
		toggleSort: header => (dispatch, getState) =>  {
			dispatch({
				type: TOGGLE_SORT,
				payload: header
			});
			actions.fetchData()(dispatch, getState);
		},
		paginate: pageNumber => (dispatch, getState) =>  {
			const limit = _get(getState(), 'discountsList.query.limit');
			dispatch({
				type: PAGINATE,
				payload: { offset: pageNumber * limit }
			});
			actions.fetchData()(dispatch, getState);
		},
		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		}),
		deleteDiscounts: id => (dispatch, getState) => {
			return confirm(`You want to delete discount with id ${id} ?`) &&
				http({
					url: endpoints.DISCOUNTS.SINGLE.replace('{id}', id),
					method: 'delete',
					actions: [DELETE_NEWS_SUCCESS, FETCH_DATA_ERROR]
				})(dispatch);
		}
	}
);

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return initialState;
		},
		[TOGGLE_SORT]: (state, action) => {
			const newColumns = {...defaultTableInitialState.columns};
			const sort = {};
			if (action.payload.isActive) {
				const direction = action.payload.direction === 'asc' ? 'desc' : 'asc';
				newColumns[action.payload.index] = {...action.payload, direction };
				sort[action.payload.index] = direction;
			} else {
				newColumns[action.payload.index] = {...action.payload, isActive: true};
				sort[action.payload.index] = action.payload.direction;
			}
			return {
				...state,
				table: {...state.table, columns: newColumns},
				query: {...state.query, sort}
			};
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return {
				...state,
				data: action.payload.data,
				showProgressBar: false,
				error: false
			};
		},
		[PAGINATE]: (state, action) => {
			return {
				...state,
				query: {
					...state.query,
					...action.payload
				}
			};
		},
		[DELETE_NEWS_SUCCESS]: state => ({
			...state,
			data: null,
			showProgressBar: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })
	}
);

// reducers
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.discountsList.data,
	getQuery: state => state.discountsList.query,
	getTable: state => {
		const { table, data } = state['discountsList'];
		const rows = data ? data : [];
		return {
			headers: values(table.columns),
			rows: rows
		};
	},
	getProgressBar: state => state.discountsList.showProgressBar,
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.newsList.error
};




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/discounts/list/index.js